import React, { useMemo } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";

const StatsCard = ({ subsList = [] }) => {
    const stats = useMemo(() => {
        const total = subsList.length;

        // Calculate Total Transactions / MRR
        const totalRevenue = subsList
            .filter(c => c.status === "Active" || c.status === "Paid")
            .reduce((acc, curr) => {
                const num = typeof curr.price === "number" ? curr.price : Number((curr.price || "").toString().replace(/[^0-9.-]+/g, "")) || 0;
                return acc + num;
            }, 0);

        const activeSubscribers = subsList.filter(c => c.status === "Active" || c.status === "Paid").length;
        const inactiveSubscribers = subsList.filter(c => c.status === "Expired" || c.status === "Inactive" || c.status === "Unpaid").length;

        const formattedRevenue = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
        }).format(totalRevenue);

        return [
            { title: "Total Subscribers", value: total, icon: "🏢", color: "#06aed4", bgColor: "#f0faff" },
            { title: "Active Revenue", value: formattedRevenue, icon: "💰", color: "#27ae60", bgColor: "#f0fff4" },
            { title: "Active Subscribers", value: activeSubscribers, icon: "✅", color: "#27ae60", bgColor: "#f0fff4" },
            { title: "Expired / Inactive", value: inactiveSubscribers, icon: "🚫", color: "#ef1e1e", bgColor: "#fff1f2" },
        ];
    }, [subsList]);

    return (
        <Row className="mb-4 gap-2">
            {stats.map((stat, index) => (
                <Col key={index} xl md="6" className="mb-3 mb-xl-0">
                    <Card className="shadow-sm border-0 h-100" style={{ borderRadius: "12px" }}>
                        <CardBody className="d-flex align-items-center p-3">
                            <div className="d-flex align-items-center justify-content-center me-3"
                                style={{ minWidth: "48px", height: "48px", backgroundColor: stat.bgColor, borderRadius: "10px", fontSize: "22px", color: stat.color }}>
                                {stat.icon}
                            </div>
                            <div>
                                <p className="text-muted mb-0 fs-6 fw-medium small">{stat.title}</p>
                                <h4 className="fw-bold mb-0">
                                    {stat.value}
                                </h4>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default StatsCard;